



































import { Component, Prop, Vue } from "vue-property-decorator";
import ContactInfo from "@/models/InsuranceInfo";
import { ValidationProvider, extend } from "vee-validate";
import { email, regex } from "vee-validate/dist/rules";
import SubmissionFormContactInfoItem from "./SubmissionFormContactInfoItem.vue";

extend("email", {
  ...email,
  message: "Proszę podać prawidłowy adres e-mail"
});

extend("phoneregex", {
  ...regex,
  message: "Proszę podać prawidłowy nr telefonu"
});

@Component({
  components: {
    ValidationProvider,
    SubmissionFormContactInfoItem
  }
})
export default class SubmissionFormContactInfo extends Vue {
  @Prop() private contactInfo!: ContactInfo;
}
